export default {
  computed: {
    isWhiteLabel () {
      return this.$route.query.userExternalId
    },
  },
}
